import { fromJS } from 'immutable';
import { actions } from 'react/api/actions/configEventHttpHeadersModal';

const initialState = fromJS({
  isOpenModal: false,
  headers: {}
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.openModal: {
      return state.set('isOpenModal', true);
    }
    case actions.closeModal: {
      return state.set('isOpenModal', false);
    }
    case actions.updateHeaders: {
      const { payload } = action;
      return state.set('headers', fromJS(payload));
    }
    default:
      return state;
  }
};
